/**
 * Chip for an Entity.
 */

import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {useEntityPhotoQuery} from '../../../generated/graphql';
import {useViewer} from '../../../state/viewer/hooks';
import * as S from './EntityChip.styles';

type EntityChipProps = {
  name: string;
};

export const EntityChip = ({name}: EntityChipProps) => {
  const viewer = useViewer();
  // Previously, the photoUrl value was retrieved along with other queue information
  // and passed to this component as a prop. Unfortunately, the URL changed every
  // time we polled, causing large profile images to be constantly re-downloaded.
  const query = useEntityPhotoQuery({
    variables: {
      entityName: name,
    },
  });
  const photoUrl = query.data?.entity?.photoUrl;
  let avatar = null;
  if (photoUrl) {
    avatar = <S.AvatarImage src={photoUrl} />;
  } else {
    const isUser = viewer?.username === name;
    const icon = isUser ? 'user-profile-personal' : 'share-with';
    avatar = (
      <S.AvatarImage>
        <Icon name={icon} />
      </S.AvatarImage>
    );
  }
  return (
    <S.EntityChip>
      {avatar}
      <div>{name}</div>
    </S.EntityChip>
  );
};
